<template>
  <section class="widget-preview mt-2 border-t pt-2" aria-label="Chat widget preview">
    <div class="preview-label">Widget Preview</div>
    <p class="preview-note">Updates as you edit. Sample conversation only.</p>
    <div class="preview-stage" :style="{ alignItems: alignment }">
      <div class="preview-chat" :style="{ color: setting.widget_text_color || '#313e42' }">
        <div class="preview-header" :style="{ background: setting.widget_header_color || '#1f242f12' }">
          <span class="preview-avatar"><i class="mdi mdi-account-outline" aria-hidden="true"></i><span></span></span>
          <div class="preview-heading">
            <strong>{{ setting.widget_title || 'Chat with us' }}</strong>
            <div v-if="setting.widget_description" class="preview-description">{{ setting.widget_description }}</div>
          </div>
          <i class="mdi mdi-restore" aria-hidden="true"></i>
        </div>
        <div class="preview-messages" :style="{ background: setting.widget_box_color || '#ffffff' }">
          <div class="preview-bubble preview-assistant" :style="{ background: setting.widget_chat_bubble_left_color || '#eeeeee' }">Hi there! How can we help you today?</div>
          <div class="preview-bubble preview-user" :style="{ background: setting.widget_chat_bubble_right_color || '#9fd4f8' }">I'd like to learn more about your services.</div>
        </div>
        <div class="preview-footer">
          <div class="preview-composer">
            <input type="text" placeholder="Type your message..." aria-label="Sample message input (preview only)" disabled />
            <span class="preview-send" :style="{ background: setting.widget_button_color || '#3a9bdb' }"><i class="mdi mdi-send-outline" aria-hidden="true"></i></span>
          </div>
          <div v-if="setting.show_powered_by" class="preview-branding">
            <i class="mdi mdi-auto-fix" aria-hidden="true"></i> AI chat powered by
            <span :title="setting.powered_by_link" :style="{ color: setting.widget_chat_bubble_right_color || '#3a9bdb' }">{{ setting.powered_by_text || 'LSA Command' }}</span>
          </div>
        </div>
      </div>
      <span class="preview-launcher" :style="{ background: setting.widget_button_color || '#3a9bdb' }" aria-hidden="true"><i class="mdi mdi-message-text-outline"></i></span>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ChatWidgetPreview',
  props: {
    setting: { type: Object, required: true }
  },
  computed: {
    alignment() {
      return { Left: 'flex-start', Centered: 'center', Right: 'flex-end' }[this.setting.floating_box_position] || 'flex-end';
    }
  }
};
</script>

<style scoped>
.preview-label { margin-bottom: 4px; font-size: 12px; font-weight: 600; color: #374151; }
.preview-note { margin: 0 0 8px; font-size: 11px; color: #6b7280; }
.preview-stage { display: flex; flex-direction: column; gap: 10px; padding: 12px; background: #f3f4f6; border: 1px solid #e5e7eb; border-radius: 8px; }
.preview-chat { width: 100%; max-width: 340px; min-width: 0; overflow: hidden; border: 1px solid #e5e7eb; border-radius: 12px; background: #fff; box-shadow: 0 4px 14px rgba(0, 0, 0, .06); font-size: 12px; }
.preview-header { display: flex; align-items: center; gap: 10px; padding: 14px 12px; }
.preview-avatar { position: relative; display: flex; align-items: center; justify-content: center; flex-shrink: 0; width: 34px; height: 34px; border-radius: 50%; background: #fff; color: #2563eb; font-size: 22px; }
.preview-avatar span { position: absolute; bottom: 0; right: 0; width: 9px; height: 9px; border-radius: 50%; background: #22c55e; border: 2px solid #fff; }
.preview-heading { flex: 1; min-width: 0; overflow-wrap: anywhere; }
.preview-heading strong { font-size: 13px; }
.preview-description { margin-top: 3px; font-size: 11px; }
.preview-messages { display: flex; flex-direction: column; gap: 14px; min-height: 175px; padding: 18px 12px; }
.preview-bubble { max-width: 85%; padding: 10px 12px; line-height: 1.5; overflow-wrap: anywhere; }
.preview-assistant { align-self: flex-start; border-radius: 14px 14px 14px 4px; }
.preview-user { align-self: flex-end; border-radius: 14px 4px 14px 14px; color: #fff; }
.preview-footer { padding: 12px; border-top: 1px solid #eee; }
.preview-composer { display: flex; align-items: center; gap: 6px; }
.preview-composer input { width: 100%; min-width: 0; height: 36px; padding: 8px; border: 1px solid #ddd; border-radius: 8px; background: #f7f7f7; font-size: 11px; }
.preview-send { display: flex; align-items: center; justify-content: center; flex-shrink: 0; width: 34px; height: 34px; border-radius: 8px; color: #fff; font-size: 18px; }
.preview-branding { margin-top: 10px; font-size: 10px; color: #999; overflow-wrap: anywhere; }
.preview-launcher { display: flex; align-items: center; justify-content: center; width: 42px; height: 42px; border-radius: 50%; color: #fff; font-size: 22px; box-shadow: 0 2px 8px rgba(0, 0, 0, .12); }
</style>
